import { TTableStructure, ETableStructureType, ETableStructureAlign } from 'ui/EasTable/types';
import { TGeneralAttachmentVersion } from 'redux/reducers/generalAttachments/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';

export type TVersionRow = TGeneralAttachmentVersion & { id: number };

export const versionTableStructure: TTableStructure<keyof TVersionRow, TVersionRow>[] = [
	{
		name: 'Version',
		selector: 'version',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Created at',
		selector: 'createdAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Attached by',
		selector: 'attachedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Comment',
		selector: 'comment',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'id',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Download',
				icon: EIconButtons.DOWNLOAD,
			},
		],
	},
];
